import { db } from "../services/firebase";
import {
	addDoc,
	collection,
	updateDoc,
	deleteDoc,
	doc,
	serverTimestamp,
} from "firebase/firestore";

/**
 * Create a PB congratulatory message in Firestore.
 * @param {string} userId - The recipient's Firebase Auth UID
 * @param {string} movement - The movement name (e.g. "Deadlift")
 * @param {string|number} value - The new PB value achieved
 * @param {string} unit - The unit of measurement (e.g. "kg", "reps")
 */
export async function createPBMessage(userId, movement, value, unit) {
	const content = `Congratulations! You hit a new personal best on ${movement} — ${value} ${unit}! Keep pushing!`;
	await addDoc(collection(db, "messages"), {
		userId,
		type: "pb_congratulation",
		title: "New PB!",
		content,
		movement,
		createdAt: serverTimestamp(),
		read: false,
	});
}

/**
 * Mark a message as read.
 * @param {string} messageId - The Firestore document ID of the message
 */
export async function markMessageRead(messageId) {
	await updateDoc(doc(db, "messages", messageId), { read: true });
}

/**
 * Delete a message document from Firestore.
 * @param {string} messageId - The Firestore document ID of the message
 */
export async function deleteMessage(messageId) {
	await deleteDoc(doc(db, "messages", messageId));
}
